export const meta = {
  id: 'A13.1',
  slug: 'conclusao-formacao',
  title: 'Como uma Formação é concluída',
  description: 'Entenda quais componentes determinam a conclusão e como o histórico é preservado.',
  profile: 'student',
  category: 'progresso',
  type: 'concept',
  status: 'published',
  order: 180,
  keywords: ['conclusão formação', 'formação concluída', 'obrigatório', 'opcional', 'histórico', 'certificado'],
  previous: 'A13',
  next: 'C01',
  related: ['A06', 'A07', 'A13'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como uma Formação é concluída

Uma Formação é considerada concluída quando os **componentes obrigatórios necessários** foram concluídos de acordo com as regras do programa.

## Obrigatório e opcional

- **Obrigatório:** precisa ser realizado para a conclusão da Formação;
- **Opcional:** pode enriquecer sua experiência, mas não impede a conclusão final.

<Callout type="important">
  Um componente opcional não bloqueia a conclusão da Formação.
</Callout>

## Histórico de conclusão

Quando uma Formação é concluída, essa conclusão faz parte do histórico do participante. O sistema preserva a conclusão e sua data mesmo diante de alterações administrativas posteriores que não devem apagar um fato histórico válido.

<HelpImage alt="Formação concluída no histórico do Aluno" pendingId="A13.1" />

## Certificado

<Callout type="info">
  A versão atual do Personagrama **não possui certificado de Formação**. A conclusão é registrada no sistema, mas não deve ser interpretada como emissão automática de certificado.
</Callout>